
import React from 'react';
import { StepProps } from '../../types';

export const ExemptPersonInfo: React.FC<StepProps> = ({ t }) => {
  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-semibold text-sky-700 mb-6">{t('exempt_person_info_step_title')}</h2>
      <div className="p-4 bg-sky-50 border border-sky-200 rounded-md">
        <p className="text-sky-700">
          {t('exempt_person_annual_declaration_guidance')}
        </p>
      </div>
    </div>
  );
};
